export const fakeData = {
  imgCategories: {
    116: 'https://images.unsplash.com/photo-1564769662533-4f00a87b4056',
    117: 'https://images.unsplash.com/photo-1551656941-dc4f2593028b',
    118: 'https://images.unsplash.com/photo-1508807526345-15e9b5f4eaff',
    119: 'https://images.unsplash.com/photo-1543704735-dcb21177026f',
    120: 'https://images.unsplash.com/photo-1521117133479-1d2f70a2d257',
    121: 'https://images.unsplash.com/photo-1582885800756-42a904ae6ab5',
    122: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/Circus_Smirkus_-_Static_Trapeze.jpg/1200px-Circus_Smirkus_-_Static_Trapeze.jpg',
    123: 'https://upload.wikimedia.org/wikipedia/commons/e/eb/V%C3%A9locourse.jpg',
    124: 'https://cdn.britannica.com/94/198194-050-0B532438/athlete-Parkour-obstacle-Vienna.jpg',
    125: 'https://upload.wikimedia.org/wikipedia/commons/1/18/US_Navy_060627-N-5290S-109_Gilad_of_the_Fit_TV_show%2C_Bodies_in_Motion%2C_films_a_show_aboard_the_amphibious_assault_ship_USS_Bonhomme_Richard_%28LHD_6%29._Sailors_participated_in_the_filming_on_the_flight_deck_during_Rim_of_the_Pacif.jpg',
    126: 'https://upload.wikimedia.org/wikipedia/commons/c/cd/Zumba.Kochi.jpg'
  },
  imgClasses: {
    170: 'https://www.seattlenorthcountry.com/imager/s3_amazonaws_com/snohomish-2018/craft/Outdoors/Goat-Yoga-4_930104bc5592b0f48aa7a928055610d9.jpg',
    179: 'https://cdn.britannica.com/94/198194-050-0B532438/athlete-Parkour-obstacle-Vienna.jpg',
    180: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Nik_Wallenda_Niagara_Falls_2012_2.jpg/1200px-Nik_Wallenda_Niagara_Falls_2012_2.jpg',
    181: 'https://www.washingtonian.com/wp-content/uploads/2017/06/6-12-17-goat-yoga-washington-dc-1.jpg'
  }
}